export default "__VITE_ASSET__BLWasEPg__"